// extracted by mini-css-extract-plugin
module.exports = {"title":"ScoreGuideModal_title__XnnsU"};